// TODO: each time a message is added to a conversation, check for dupes + time ordering

import Emoticons from '../../emoticons/emoticons';
import $ from 'jquery';
import '../../vendor/jquery/plugins/makeClass';
import * as API from '../../API/API';
var RealTime = null; // import 'realTime/realTime';
import async from 'async';
import { captureException } from '@sentry/browser';

export default (function() {
  // generates a unique, time-stamped, identifier
  var makeUniqueID = function() {
    var text = '';
    var possible =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (var i = 0; i < 6; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text + new Date().getTime();
  };

  var lastTempID = 0;
  var makeTempID = function() {
    return --lastTempID;
  };

  var insertIntoConversation = function(message, conversation) {
    var i;
    var messages = conversation.messages;

    for (i = messages.length - 1; i !== -1; --i) {
      if (messages[i].id < message.id) {
        break;
      } else if (messages[i].id === message.id) {
        return false;
      }
    }
    messages.splice(i + 1, 0, message);
    conversation.numMessages = Math.max(conversation.numMessages, message.id);
    if (message.from === messaging.myProfileName) {
      conversation.lastMessageSeen = Math.max(
        conversation.lastMessageSeen,
        message.id
      );
    }
    return true;
  };

  // For sorting conversations from newest to oldest
  var conversationSortComparator = function(a, b) {
    var keyA = messaging.conversations[a].lastActivity.toLowerCase();
    var keyB = messaging.conversations[b].lastActivity.toLowerCase();
    if (keyA < keyB) {
      return 1;
    } else if (keyA > keyB) {
      return -1;
    } else {
      return 0;
    }
  };

  var messaging = {
    windowId: makeUniqueID(),
    isConnected: false,
    isChatConnected: false,
    handlers: {},
    myProfileName: null,
    myCohorts: [],
    selectedCohort: null,
    lastCohortChange: 0,
    onlineContacts: {},
    numOnlineContacts: 0,
    contacts: {},
    contactGroups: {},
    availableContactsByCohort: {},
    status: 'offline',
    contactsExpanded: false,
    isIdle: false,
    conversations: {},
    conversationIndexes: [],
    readyCallbacks: [],
    isReady: false,
    realTime: null,
    presences: {},
    conversationChannels: {},
    systemChannel: null,

    // initialise User Messaging with options
    init: function(options) {
      messaging.realTime = RealTime.getClient('chat');
      var defaultOptions;

      defaultOptions = {
        myProfileName: '',
        numConversationsLoaded: 100,
        numMessagesLoaded: 20,
      };

      messaging.options = $.extend(defaultOptions, options);
      messaging.myProfileName = messaging.options.myProfileName;
      messaging.myAvatar = messaging.options.myAvatar;
      messaging.emoticons = Emoticons(messaging.options.emoticonURL);

      if (messaging.isConnected) {
        return false;
      }

      // subscribe to the user channel for receiving new messages
      var rt = messaging.realTime;
      var channel_names = [
        'personal-message',
        'own-conversation-read',
        'new-conversation-status',
        'new-contacts-expanded-status',
        'new-contacts-filter-status',
      ];
      messaging.conversationChannels = channel_names.reduce(function(
        channels,
        channel_name
      ) {
        channels[channel_name] = rt.channel([
          messaging.myProfileName,
          channel_name,
        ]);
        return channels;
      },
      messaging.conversationChannels);
      messaging.systemChannel = rt.channel([
        messaging.myProfileName,
        'system-message',
      ]);

      messaging.conversationChannels['personal-message'].watch(
        messaging.onMessage
      );
      messaging.conversationChannels['own-conversation-read'].watch(
        messaging.onOwnConversationRead
      );
      messaging.conversationChannels['new-conversation-status'].watch(
        messaging.onNewConversationStatus
      );
      messaging.conversationChannels['new-contacts-expanded-status'].watch(
        messaging.onNewContactsExpandedStatus
      );
      messaging.conversationChannels['new-contacts-filter-status'].watch(
        messaging.onNewContactsFilterStatus
      );
      messaging.systemChannel.watch(messaging.onSystemMessage);

      messaging.conversationChannels['personal-message'].on(
        'subscribe',
        function() {
          if (messaging.isReady) {
            $.each(messaging.conversationIndexes, function(_, conversationID) {
              var localConversation = messaging.conversations[conversationID];
              messaging.loadNewMessages(
                conversationID,
                localConversation.numMessages,
                1000,
                function(rawMessages) {
                  for (var i in rawMessages) {
                    var message = rawMessages[i];
                    message.conversation = conversationID;
                    messaging.onMessage(message);
                  }
                }
              );
            });
          }
        }
      );

      messaging.isConnected = true;
      messaging.getOnlineStatus(function(onlineStatus, contactsExpanded) {
        messaging.status = onlineStatus;
        messaging.contactsExpanded = contactsExpanded;
        var executeReady = function(onlineStatus, contactsExpanded) {
          messaging.isReady = true;
          $.each(messaging.readyCallbacks, function(i, callback) {
            if (typeof callback === 'function') {
              callback(onlineStatus, contactsExpanded);
            }
          });
        };

        // Subscribe whether or not chat is connected in case it is subsequently turned on in another tab
        messaging.systemChannel.subscribe();

        if (onlineStatus === 'online') {
          messaging.connectChat(true, function(conversations) {
            executeReady(messaging.status, messaging.contactsExpanded);
          });
        } else {
          executeReady(messaging.status, messaging.contactsExpanded);
        }
      });
    },

    ready: function(callback) {
      if (!messaging.isReady) {
        messaging.readyCallbacks.push(callback);
      } else {
        callback(
          messaging.status,
          messaging.contactsExpanded,
          messaging.conversations
        );
      }
    },

    // add an event handler. Currently supported:
    //  'chatDisconnect' - on disconnecting chat
    //  'chatConnect' - on connecting chat
    //  'chatIdle' - on window becoming idle
    //  'chatReturn' - on user returning to window (no longer idle)
    //  'onlineContactsUpdate' - on receiving a new contact list
    //  'newContacts' - on receiving new offline contacts
    //  'newMessage' - on receiving a new message
    //  'newConversation' - on starting a new conversation
    //  'error' - on an error occurring
    //  'systemMessage' - on receiving any system message (server push notification)
    //  'system:<eventName>' - on receving a particular system message
    // each event handler can be given a name space
    addHandler: function() {
      var eventName;
      var handlerName;
      var callback;

      if (arguments.length === 3) {
        eventName = arguments[0];
        handlerName = arguments[1];
        callback = arguments[2];
      } else {
        eventName = arguments[0];
        handlerName = 'default';
        callback = arguments[1];
      }

      eventName = eventName.toLowerCase();
      handlerName = handlerName.toLowerCase();

      messaging.handlers[eventName] = messaging.handlers[eventName] || {};
      messaging.handlers[eventName][handlerName] =
        messaging.handlers[eventName][handlerName] || [];
      messaging.handlers[eventName][handlerName].push(callback);
    },

    // remove an event handler (given its name space)
    removeHandler: function(eventName, handlerName) {
      var eventHandlers = messaging.handlers[eventName];

      eventName = eventName.toLowerCase();

      if (!handlerName) {
        handlerName = 'default';
      }
      handlerName = handlerName.toLowerCase();

      if (eventHandlers) {
        delete eventHandlers[handlerName];
      }
    },

    // execute all named handlers
    executeHandlers: function() {
      var eventName = arguments[0].toLowerCase();
      var args = Array.prototype.slice.call(arguments, 1);

      if (messaging.handlers[eventName]) {
        $.each(messaging.handlers[eventName], function(handlerName, handlers) {
          if (handlers && handlers.length > 0) {
            $.each(handlers, function(i, delegate) {
              try {
                delegate.apply(messaging, args);
              } catch (exception) {
                if (_DEBUG) {
                  captureException(exception);
                }
              }
            });
          }
        });
      }
    },

    // return how many handlers are listening for a particular event
    numHandlers: function(eventName) {
      var count = 0;
      eventName = eventName.toLowerCase();

      if (messaging.handlers[eventName]) {
        $.each(messaging.handlers[eventName], function(handlerName, handlers) {
          count += handlers.length;
        });
      }

      return count;
    },

    makeCohortOnlineListHandler: function(cohortPath) {
      return function(onlineList) {
        messaging.processCohortOnlineContactsList(
          cohortPath,
          onlineList.contacts,
          onlineList.groups
        );
      };
    },

    disableIdleTimeout: function() {
      messaging.idleDisabled = true;
    },

    onIdle: function() {
      if (messaging.idleDisabled) {
        return;
      }

      messaging.executeHandlers('chatIdle', {});
      messaging.isIdle = true;
    },

    onReturn: function() {
      var isReconnect = false;

      if (messaging.isIdle) {
        // returning to a timed-out window

        messaging.getOnlineStatus(function(status) {
          if (status === 'online') {
            // user is still online, upon returning to this window

            // bind to new channel
            if (isReconnect) {
              var rt = messaging.realTime;
              // bind to receiving messages from others
              rt.subscribe([messaging.myProfileName, 'personal-message']);

              rt.subscribe([messaging.myProfileName, 'own-conversation-read']);

              rt.subscribe([
                messaging.myProfileName,
                'new-conversation-status',
              ]);

              rt.subscribe([
                messaging.myProfileName,
                'new-contacts-expanded-status',
              ]);

              rt.subscribe([
                messaging.myProfileName,
                'new-contacts-filter-status',
              ]);
            }

            messaging.executeHandlers('chatReturn', {});
          } else {
            // chat has been disconnected while we've been idle
            messaging.disconnectChat(true);
          }

          // re-enable keep-alives
          messaging.isIdle = false;
        });
      }
    },

    onSystemMessage: function(message) {
      messaging.executeHandlers('systemMessage', message);
      messaging.executeHandlers('system:' + message.eventName, message);

      if (message === 'disconnectChat') {
        messaging.disconnectChat(true);
      } else if (message === 'connectChat') {
        messaging.connectChat(true);
      }
    },

    onMessage: function(message) {
      if (!messaging.isChatConnected) {
        return;
      }
      var conversationID, conversation;
      message.html = messaging.emoticons.insertIntoText(message.text);
      conversationID = message.conversation;

      messaging.createConversation(conversationID, function(conversation) {
        if (message.windowId !== messaging.windowId) {
          if (insertIntoConversation(message, conversation)) {
            messaging.executeHandlers('newMessage', message, conversationID);
          }
        }
      });
    },

    onOwnConversationRead: function(conversationReadStatus) {
      var sourceWindow = conversationReadStatus.sourceWindow;
      var conversationID = conversationReadStatus.conversationID;
      var lastMessageSeen = conversationReadStatus.lastMessageSeen;
      messaging.createConversation(conversationID, function(conversation) {
        conversation.lastMessageSeen = lastMessageSeen;
        if (messaging.isChatConnected) {
          messaging.executeHandlers(
            'ownConversationRead',
            conversationID,
            lastMessageSeen
          );
        }
      });
    },

    onNewConversationStatus: function(conversationStatus) {
      if (messaging.isChatConnected) {
        // On receiving a new conversationStatus from another window
        messaging.createConversation(
          conversationStatus.conversationID,
          function(conversation) {
            if (conversationStatus.actionTime > conversation.lastStatusTime) {
              conversation.lastStatusTime = conversationStatus.actionTime;
              conversation.windowStatus = conversationStatus.windowStatus;
              if (conversationStatus.lastOpened) {
                conversation.lastOpened = conversationStatus.lastOpened;
              }
              messaging.executeHandlers(
                'newConversationStatus',
                conversationStatus
              );
            }
          }
        );
      }
    },

    onNewContactsExpandedStatus: function(newStatus) {
      if (
        messaging.isChatConnected &&
        newStatus.sourceWindow !== messaging.windowId
      ) {
        messaging.executeHandlers(
          'newContactsExpandedStatus',
          newStatus.contactsExpandedStatus === 'true'
        );
      }
    },

    onNewContactsFilterStatus: function(newStatus) {
      if (
        messaging.isChatConnected &&
        messaging.lastCohortChange < newStatus.actionTime
      ) {
        messaging.lastCohortChange = newStatus.actionTime;
        messaging.executeHandlers(
          'newContactsFilterGroup',
          newStatus.filterGroup
        );
      }
    },

    // disconnect from chat messaging
    disconnectChat: function(isActionedInternally) {
      if (!messaging.isChatConnected) {
        return;
      }
      var rt = messaging.realTime;

      messaging.conversationChannels['personal-message'].unsubscribe();
      messaging.conversationChannels['own-conversation-read'].unsubscribe();
      messaging.conversationChannels['new-conversation-status'].unsubscribe();
      messaging.conversationChannels[
        'new-contacts-expanded-status'
      ].unsubscribe();
      messaging.conversationChannels[
        'new-contacts-filter-status'
      ].unsubscribe();

      for (var i = 0; i < messaging.myCohorts.length; i++) {
        var cohortPath = messaging.myCohorts[i];
        messaging.goOfflineInCohort(cohortPath);
      }

      rt.off('idle', messaging.onIdle);
      rt.off('return', messaging.onReturn);

      messaging.isChatConnected = false;
      if (!isActionedInternally) {
        messaging.setOnlineStatus('offline');
      }

      messaging.executeHandlers('chatDisconnect', isActionedInternally);
    },

    // connect to chat messaging
    connectChat: function(isActionedInternally, callback) {
      if (messaging.isChatConnected) {
        if (typeof callback === 'function') {
          callback();
        }
        return;
      }

      var startChat = function() {
        var rt = messaging.realTime;

        if (!messaging.onlineListHandlersInitialised) {
          messaging.onlineListHandlersInitialised = true;
          for (var i = 0; i < messaging.myCohorts.length; i++) {
            var cohortPath = messaging.myCohorts[i];
            messaging.availableContactsByCohort[cohortPath] = {};
            messaging.presences[cohortPath] = rt.getPresence(
              cohortPath,
              'desktop'
            );
            messaging.presences[cohortPath].on(
              'onlinelist',
              messaging.makeCohortOnlineListHandler(cohortPath)
            );
          }
          // Windowing events
          rt.on('idle', messaging.onIdle);
          rt.on('return', messaging.onReturn);
        }

        rt.whenReady(function() {
          async.map(
            Object.keys(messaging.conversationChannels),
            function(channelName, callback) {
              var channel = messaging.conversationChannels[channelName];
              if (channel.isSubscribed()) {
                callback(null);
              } else {
                channel.once('subscribe', function(channelName) {
                  callback(null);
                });
                channel.subscribe();
              }
            },
            function(err, results) {
              for (var i = 0; i < messaging.myCohorts.length; i++) {
                var cohortPath = messaging.myCohorts[i];
                messaging.goOnlineInCohort(cohortPath);
              }

              messaging.isChatConnected = true;
              messaging.executeHandlers('chatConnect', isActionedInternally);

              if (typeof callback === 'function') {
                callback();
              }
            }
          );
        });
      };

      if (messaging.options.numConversationsLoaded > 0) {
        $.userMessaging.loadActiveConversations(
          messaging.options.numConversationsLoaded,
          messaging.options.numMessagesLoaded,
          startChat
        );
      } else {
        startChat();
      }

      if (!isActionedInternally) {
        // set status to online and reinit conversations
        messaging.setOnlineStatus('online');
      }

      return true;
    },

    goOnlineInCohort: function(cohortPath) {
      messaging.presences[cohortPath].setAvailability(true);
    },

    goOfflineInCohort: function(cohortPath) {
      messaging.presences[cohortPath].setAvailability(false);
    },

    addContacts: function(contacts, groups, callback) {
      var newContacts = [];
      for (var profileName in contacts) {
        if (!(profileName in messaging.contacts)) {
          messaging.contacts[profileName] = contacts[profileName];
          messaging.contacts[profileName].online = false;
          newContacts.push(profileName);
        }
      }
      var newGroups = [];
      if (groups) {
        for (var groupPath in groups) {
          if (!(groupPath in messaging.contactGroups)) {
            messaging.contactGroups[groupPath] = groups[groupPath];
            messaging.contactGroups[groupPath].numOnline = 0;
            newGroups.push(groupPath);
          }
        }
      }

      if (newContacts.length) {
        messaging.executeHandlers('newContacts', newContacts, newGroups);
      }

      if (typeof callback === 'function') {
        callback(newContacts, newGroups);
      }
    },

    getNumOnline: function(group) {
      var selfInGroup = false;
      if (group) {
        for (var index in messaging.myCohorts) {
          var groupPath = messaging.myCohorts[index];
          if (groupPath === group) {
            selfInGroup = true;
          }
        }
        if (
          selfInGroup &&
          messaging.myProfileName in messaging.onlineContacts
        ) {
          return messaging.contactGroups[group].numOnline - 1;
        } else if (selfInGroup) {
          return messaging.contactGroups[group].numOnline;
        } else {
          return 0;
        }
      } else {
        if (messaging.myProfileName in messaging.onlineContacts) {
          return messaging.numOnlineContacts - 1;
        } else {
          return messaging.numOnlineContacts;
        }
      }
    },

    processCohortOnlineContactsList: function(
      cohort,
      cohortOnlineNow,
      groups,
      callback
    ) {
      var globalOnline = messaging.onlineContacts;
      var globalContacts = messaging.contacts;
      var globalNewlyOffline = [];
      var globalNewlyOnline = [];
      var globalNewContacts = [];
      var globalNewGroups = [];

      var profileName;

      // Check for any new cohorts
      for (var groupPath in groups) {
        if (!(groupPath in messaging.contactGroups)) {
          messaging.contactGroups[groupPath] = groups[groupPath];
          messaging.contactGroups[groupPath].numOnline = 0;
          globalNewGroups.push(groupPath);
          messaging.availableContactsByCohort[groupPath] = {};
        }
      }

      var cohortAvailable = messaging.availableContactsByCohort[cohort];

      // Remove contacts from the per cohort online list
      for (profileName in cohortAvailable) {
        if (!(profileName in cohortOnlineNow)) {
          delete cohortAvailable[profileName];
          messaging.contactGroups[cohort].numOnline--;
        }
      }

      // Possible remove from the global online list
      for (profileName in globalOnline) {
        // Work out if they are online in any cohorts
        var availByCohort = messaging.availableContactsByCohort;
        var online = false;
        for (var cohortPath in availByCohort) {
          if (profileName in availByCohort[cohortPath]) {
            online = true;
            break;
          }
        }

        // If not...
        if (!online) {
          delete globalOnline[profileName];
          globalContacts[profileName].online = false;
          globalNewlyOffline.push(profileName);
        }
      }

      // Add any newly online contacts
      for (profileName in cohortOnlineNow) {
        // Ensure contact is in the global contacts list
        if (!(profileName in globalContacts)) {
          globalContacts[profileName] = cohortOnlineNow[profileName];
          globalNewContacts.push(profileName);
        } else {
          // Ensure this cohort is in this contact's groups
          if (globalContacts[profileName].groups.indexOf(cohort) === -1) {
            globalContacts[profileName].groups.push(cohort);
          }
        }

        // Ensure contact is in the global available list
        if (!(profileName in globalOnline)) {
          globalOnline[profileName] = globalContacts[profileName];
          globalNewlyOnline.push(profileName);
          globalContacts[profileName].online = true;
        }

        // Ensure contact is in the per-cohort available list
        if (!(profileName in cohortAvailable)) {
          cohortAvailable[profileName] = globalContacts[profileName];
          messaging.contactGroups[cohort].numOnline++;
        }
      }

      messaging.numOnlineContacts +=
        globalNewlyOnline.length - globalNewlyOffline.length;

      if (globalNewContacts.length) {
        messaging.executeHandlers(
          'newContacts',
          globalNewContacts,
          globalNewGroups
        );
      }

      if (globalNewlyOffline.length || globalNewlyOnline.length) {
        messaging.executeHandlers(
          'onlineContactsUpdate',
          globalNewlyOnline,
          globalNewlyOffline
        );
      }

      if (typeof callback === 'function') {
        callback(globalNewlyOnline, globalNewlyOffline);
      }
    },

    // send a private message to recipient
    sendPrivateMessage: function(
      conversationID,
      messageText,
      sentCallback,
      errorCallback
    ) {
      var message = {
        windowId: messaging.windowId,
        text: messageText,
      };

      var messageHTML = messaging.emoticons.insertIntoText(messageText);

      var ownMessage = {
        id: makeTempID(),
        windowId: messaging.windowId,
        from: messaging.myProfileName,
        text: messageText,
        html: messageHTML,
        time: new Date().toISOString(),
      };

      messaging.createConversation(conversationID, function(conversation) {
        var otherProfileName;
        var participants = conversationID.split('_with_');
        for (var i in participants) {
          if (participants[i] !== messaging.myProfileName) {
            otherProfileName = participants[i];
          }
        }
        API.post('chat/postToConversation/' + conversationID + '/', message)
          .done(function(response) {
            ownMessage.id = response.messageNumber;
            ownMessage.time = response.timeSent;
            insertIntoConversation(ownMessage, conversation);
            if (sentCallback) {
              sentCallback(response.messageNumber, response.timeSent);
            }
          })
          .fail(function(error, response) {
            if (errorCallback) {
              errorCallback(ownMessage);
            }
          });
      });

      return ownMessage;
    },

    // get the online/offline status of chat
    getOnlineStatus: function(callback) {
      API.get('chat/status/').done(function(response) {
        messaging.status = response.status;
        messaging.contactsExpanded =
          response.contactsExpandedStatus !== 'false';
        for (var index in response.groups) {
          messaging.myCohorts.push(response.groups[index].path);
          if (!messaging.contactGroups[response.groups[index].path]) {
            messaging.contactGroups[response.groups[index].path] =
              response.groups[index];
            messaging.contactGroups[response.groups[index].path].numOnline = 0; // This user
          }
        }
        messaging.selectedCohort = response.selectedGroup;
        callback(response.status, messaging.contactsExpanded);
      });
    },

    // set the online/offline status of chat
    setOnlineStatus: function(status, callback) {
      API.post('chat/status/', {
        status: status,
      }).done(function(response) {
        messaging.status = status;
        if (typeof callback === 'function') {
          callback(response);
        }
      });
    },

    setFilterGroup: function(filterGroup, callback) {
      API.post('chat/status/', {
        contactsFilterGroup: filterGroup,
      }).done(function(response) {
        if (typeof callback === 'function') {
          callback(response);
        }
      });
    },

    getConversationID: function(otherParty) {
      return [otherParty, messaging.myProfileName].sort().join('_with_');
    },

    // load previous messages (without bothering to put them in the conversation object...)
    loadMessageHistory: function(
      conversationID,
      lastIndex,
      numMessages,
      callback
    ) {
      API.get('chat/listConversations/', {
        index: conversationID,
        lastMessageIndex: lastIndex,
        numMessages: numMessages,
      })
        .done(function(response) {
          $.each(response.conversations[0].rawMessages, function(i, message) {
            message.html = messaging.emoticons.insertIntoText(message.text);
          });

          response.conversations[0].messages =
            response.conversations[0].rawMessages;
          callback(response.conversations[0].rawMessages);
        })
        .fail(function(response) {
          messaging.executeHandlers('error', response);
        });
    },

    // load messages after the id specified (without bothering to put them in the conversation object...)
    loadNewMessages: function(
      conversationID,
      afterIndex,
      numMessages,
      callback
    ) {
      API.get('chat/listConversations/', {
        index: conversationID,
        firstMessageIndex: afterIndex + 1,
        numMessages: numMessages,
      })
        .done(function(response) {
          if (!response.conversations.length) {
            callback([]);
            return;
          }
          $.each(response.conversations[0].rawMessages, function(i, message) {
            message.html = messaging.emoticons.insertIntoText(message.text);
          });

          response.conversations[0].messages =
            response.conversations[0].rawMessages;
          callback(response.conversations[0].rawMessages);
        })
        .fail(function(response) {
          messaging.executeHandlers('error', response);
        });
    },

    searchContacts: function(searchTerm, cohortPaths, callback) {
      API.get('chat/searchContacts/', {
        searchTerm: searchTerm,
        cohorts: cohortPaths,
        showContactGroups: true,
      }).done(function(response) {
        messaging.addContacts(response.contacts, response.groups);
        var matchedList = [];
        for (var profileName in response.contacts) {
          matchedList.push(profileName);
        }
        if (typeof callback === 'function') {
          callback(matchedList, response.isComplete);
        }
      });
    },

    createConversation: function(conversationID, callback) {
      var otherProfileName;
      var participants = conversationID.split('_with_');
      for (var i in participants) {
        if (participants[i] !== messaging.myProfileName) {
          otherProfileName = participants[i];
        }
      }

      if (conversationID in messaging.conversations) {
        // Nothing to do
        if (typeof callback === 'function') {
          callback(messaging.conversations[conversationID]);
        }
        return;
      }
      var meContact, otherContact;

      var onReceiveAllContacts = function() {
        var newConversation = {
          participants: participants,
          index: conversationID,
          lastActivity: new Date().toISOString(),
          lastViewed: new Date().toISOString(),
          lastOpened: new Date().getTime() / 1000,
          numMessages: 0,
          lastMessageSeen: 0,
          lastStatusTime: 0,
          isActive: true,
          messages: [],
        };
        messaging.conversations[newConversation.index] = newConversation;
        messaging.conversationIndexes.push(newConversation.index);
        messaging.conversationIndexes.sort(conversationSortComparator);
        messaging.executeHandlers('newConversation', newConversation);
        callback(newConversation);
      };

      var contactsReceived = 0;
      var numMissingParticipants = 0;
      var onReceiveContact = function(response) {
        contactsReceived++;
        messaging.addContacts(response.contacts, response.groups);

        if (response.contacts.profileName == messaging.myProfileName) {
          meContact = response.contacts[0];
        } else {
          otherContact = response.contacts[0];
        }

        if (contactsReceived == numMissingParticipants) {
          onReceiveAllContacts();
        }
      };

      API.get('chat/listConversations/', {
        index: conversationID,
        numMessages: 25,
        showActiveStatus: true,
        showWindowStatus: true,
        showGroups: true,
        showContacts: true,
      }).done(function(response) {
        var conversations = response.conversations;
        var newConversation;

        messaging.addContacts(response.contacts, response.groups);

        if (conversations.length === 0) {
          if (!(messaging.myProfileName in messaging.contacts)) {
            numMissingParticipants++;
            API.get('users/' + messaging.myProfileName, {
              showGroups: true,
            }).done(onReceiveContact);
          }
          if (!(otherProfileName in messaging.contacts)) {
            numMissingParticipants++;
            API.get('users/' + otherProfileName, {
              showGroups: true,
            }).done(onReceiveContact);
          }
          if (numMissingParticipants === 0) {
            onReceiveAllContacts();
          }
          return; // The callback will happen after all users have been received
        } else {
          newConversation = conversations[0];
          newConversation.lastStatusTime = 0;
          newConversation.messages = newConversation.rawMessages;
          $.each(newConversation.messages, function(i, message) {
            message.html = messaging.emoticons.insertIntoText(message.text);
          });
          messaging.conversations[newConversation.index] = newConversation;
          messaging.conversationIndexes.push(newConversation.index);
          messaging.conversationIndexes.sort(conversationSortComparator);
          messaging.executeHandlers('newConversation', newConversation);
          if (typeof callback === 'function') {
            callback(newConversation);
          }
        }
      });
    },

    // load active conversations
    loadActiveConversations: function(numConversations, numMessages, callback) {
      return messaging.loadConversations(
        numConversations,
        numMessages,
        function(conversations, indexes) {
          messaging.conversations = conversations;
          messaging.conversationIndexes = indexes;
          if (typeof callback === 'function') {
            callback(conversations, indexes);
          }
        },
        true
      );
    },

    // load previous conversations
    loadConversations: function(
      numConversations,
      numMessages,
      callback,
      activeOnly,
      onOrBefore
    ) {
      var getData = {
        numConversations: numConversations,
        numMessages: numMessages,
        showActiveStatus: true,
        showWindowStatus: true,
        showGroups: true,
        showContacts: true,
      };

      if (activeOnly) {
        getData['activeOnly'] = true;
      }

      if (onOrBefore) {
        getData['lastLastActivity'] = onOrBefore;
      }

      var callbackIndexes = [];
      var callbackConversations = {};

      API.get('chat/listConversations/', getData).done(function(response) {
        messaging.addContacts(response.contacts, response.groups);
        var conversations = response.conversations;
        $.each(conversations, function(i, conversation) {
          conversation.lastStatusTime = 0;
          var messages = [];

          $.each(conversation.rawMessages, function(messageI, message) {
            message.html = messaging.emoticons.insertIntoText(message.text);
            messages.push(message);
          });
          conversation.messages = messages;

          callbackIndexes.push(conversation.index);
          callbackConversations[conversation.index] = conversation;

          if (!(conversation.index in messaging.conversations)) {
            messaging.conversations[conversation.index] = conversation;
            messaging.conversationIndexes.push(conversation.index);
          }
        });
        messaging.conversationIndexes.sort(conversationSortComparator);
        callback(callbackConversations, callbackIndexes, messaging.contacts);
      });
    },

    setConversationAsClosed: function(conversationID, callback) {
      API.post('chat/setWindowStatus/' + conversationID + '/', {
        sourceWindow: messaging.windowId,
        windowStatus: 'closed',
      }).done(function(response) {
        if (typeof callback === 'function') {
          callback();
        }
      });
    },

    // save that a conversation has been viewed
    setLastMessageSeen: function(conversationID, lastSeen, callback) {
      if (lastSeen > messaging.conversations[conversationID].lastMessageSeen) {
        messaging.conversations[conversationID].lastMessageSeen = lastSeen;
        API.post('chat/setLastMessageSeen/' + conversationID + '/', {
          sourceWindow: messaging.windowId,
          lastSeen: lastSeen,
        }).done(function(response) {
          if (typeof callback === 'function') {
            callback();
          }
        });
      }
    },

    // Save the window status of a conversation (open/closed/minimised)
    setWindowStatus: function(conversationID, windowStatus, callback) {
      if (windowStatus == 'closed') {
        this.setConversationAsClosed(conversationID, callback);
      } else {
        API.post('chat/setWindowStatus/' + conversationID + '/', {
          sourceWindow: messaging.windowId,
          windowStatus: windowStatus,
        }).done(function(response) {
          if (typeof callback === 'function') {
            callback();
          }
        });
      }
    },

    setContactsExpandedStatus: function(expandedStatus, callback) {
      API.post('chat/status/', {
        sourceWindow: messaging.windowId,
        contactsExpandedStatus: expandedStatus ? 'true' : 'false',
      }).done(function() {
        messaging.contactsExpanded = expandedStatus;
        if (typeof callback === 'function') {
          callback();
        }
      });
    },

    // Load data about a particular contact (possibly offline)
    getContact: function(profileName, callback) {
      API.get('users/' + profileName, {
        showGroups: true,
      })
        .done(function(response) {
          messaging.addContacts(response.contacts, response.groups);
          callback(response);
        })
        .fail(function(response) {
          messaging.executeHandlers('error', response);
        });
    },

    getContacts: function() {
      return {
        contacts: messaging.contacts,
        groups: messaging.contactGroups,
      };
    },

    // load contact list
    loadContacts: function(callback) {
      // TODO get the real contact list
      callback({ contacts: {}, groups: {} });
    },
  };

  messaging.on = messaging.addHandler;
  messaging.off = messaging.removeHandler;

  $.userMessaging = messaging;
  $(() => {
    if (document.getElementById('user-messaging-data') !== null) {
      // If a user is logged in
      var chatData = require('./chatDataLoader').data;
      RealTime = require('../../realTime/realTime');
      messaging.init(chatData.userMessaging);
    }
  });
})();
